import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Select, { AsyncCreatableSelect, AsyncSelect } from '@atlaskit/select';
import { getDropDownMenuPosition } from '../common/commonDropDownMenuProps';
import { SelectErrorContainer } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
import { messages } from './messages';
export var EditDropdownMultiselect = function EditDropdownMultiselect(_ref) {
  var id = _ref.id,
    options = _ref.options,
    value = _ref.value,
    loading = _ref.loading,
    loadOptions = _ref.loadOptions,
    isCreatable = _ref.isCreatable,
    onChange = _ref.onChange,
    hasOtherOption = _ref.hasOtherOption,
    otherOptionSelected = _ref.otherOptionSelected,
    otherOptionText = _ref.otherOptionText,
    onOtherOptionTextChange = _ref.onOtherOptionTextChange,
    isInvalid = _ref.isInvalid,
    isRequired = _ref.isRequired,
    customComponents = _ref.customComponents,
    label = _ref.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasBeenFocused = _useState2[0],
    setHasBeenFocused = _useState2[1];
  if (loadOptions === undefined) {
    return /*#__PURE__*/React.createElement(SelectErrorContainer, {
      isInvalid: isInvalid
    }, /*#__PURE__*/React.createElement(Select, _extends({
      id: id,
      options: options,
      value: value,
      isLoading: loading,
      onChange: onChange,
      isMulti: true
    }, getDropDownMenuPosition(), {
      isSearchable: true,
      noOptionsMessage: function noOptionsMessage() {
        return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
      },
      placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
      isRequired: isRequired,
      label: label
    })), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
      dropdown: true,
      value: otherOptionText,
      isDisabled: !otherOptionSelected,
      onChange: onOtherOptionTextChange,
      id: id
    }));
  }
  var MaybeCreatableAsyncSelect = isCreatable ? AsyncCreatableSelect : AsyncSelect;
  return /*#__PURE__*/React.createElement(SelectErrorContainer, {
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement(MaybeCreatableAsyncSelect, _extends({
    autoFocus: hasBeenFocused,
    defaultMenuIsOpen: hasBeenFocused,
    defaultOptions: hasBeenFocused,
    id: id,
    isMulti: true,
    isSearchable: true,
    isValidNewOption: isCreatable ? function (inputValue) {
      return inputValue.length > 0 && !inputValue.includes(' ');
    } : undefined,
    key: id + hasBeenFocused,
    isLoading: loading,
    noOptionsMessage: function noOptionsMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownNoOptions);
    },
    loadOptions: loadOptions,
    loadingMessage: function loadingMessage() {
      return /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownLoading);
    },
    onChange: onChange,
    onFocus: function onFocus() {
      return setHasBeenFocused(true);
    },
    placeholder: /*#__PURE__*/React.createElement(FormattedMessage, messages.choiceDropdownSelect),
    value: value
  }, getDropDownMenuPosition(), {
    components: customComponents,
    label: label
  })));
};